import React from "react";
import useCountryPathologies from "../../../../components/Candidato/useCountryPathologies";
import useServiceQuery from "../../../../queries/service/useServiceQuery";
import useWindowWidth from "../../../../util/useWindowWidth";
import ServiceEditValuationPage from "./ServiceEditValuationPage";

interface IServiceEditValuationPageContainer {
  match: {
    params: {
      serviceId: string;
    };
  };
}

const ServiceEditValuationPageContainer = (
  props: IServiceEditValuationPageContainer
) => {
  const { match } = props;

  const serviceQuery = useServiceQuery(match.params.serviceId);
  const windowWidth = useWindowWidth();
  const pathologyOptions = useCountryPathologies(
    serviceQuery.data?.Business_Country ?? "es"
  );

  if (!serviceQuery.data) {
    return null;
  }

  if (pathologyOptions.length === 0) {
    return null;
  }

  return (
    <ServiceEditValuationPage
      service={serviceQuery.data}
      isLoading={serviceQuery.isLoading}
      pathologyOptions={pathologyOptions}
      windowWidth={windowWidth}
    />
  );
};

export default ServiceEditValuationPageContainer;
